import { RegisterOptions } from 'react-hook-form';

export const birthdateMinLength = ( message: string ): RegisterOptions['minLength'] => {
  return {
    value: 8,
    message,
  };
};
